// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4501":"cd7de3e9","6301":"e920059b"}[chunkId] + ".chunk.css";
};